import { render, staticRenderFns } from "./Tc.vue?vue&type=template&id=e20de400"
import script from "./Tc.vue?vue&type=script&lang=js"
export * from "./Tc.vue?vue&type=script&lang=js"
import style0 from "./Tc.vue?vue&type=style&index=0&id=e20de400&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports